import { all, fork, put, takeEvery } from 'redux-saga/effects';
import callToAPI from '../../../../utils/callToAPI';
import * as ApiV2 from '../../../api/scannedDocumentsRC/noValidatedRCScannedDocuments';
import * as Api from '../../../api/scannedDocuments';

import NoValidatedSD from '../../../../models/NoValidatedSD';
import * as types from './types';

function* deleteNoValidatedScannedDocument({ payload }) {
  yield callToAPI({
    apiCall: Api.deleteScannedDocument,
    successResponseCode: 200,
    errorType: types.DELETE_NO_VALIDATED_RC_SCANNED_DOCUMENT_ERROR,
    *callback() {
      yield put({
        type: types.DELETE_NO_VALIDATED_RC_SCANNED_DOCUMENT_SUCCESS,
        payload,
      });
    },
    payload,
  });
}

function* getNoValidatedScannedDocuments({ payload }) {
  yield callToAPI({
    apiCall: ApiV2.getNoValidatedSD,
    successResponseCode: 200,
    errorType: types.GET_NO_VALIDATED_RC_SCANNED_DOCUMENTS_ERROR,
    *callback({ data: { data, total } }) {
      yield put({
        type: types.GET_NO_VALIDATED_RC_SCANNED_DOCUMENTS_SUCCESS,
        payload: {
          noValidatedScannedDocuments: data.map((sd) => {
            return new NoValidatedSD(sd);
          }),
          total: total,
        },
      });
    },
    payload,
  });
}
function* watcherDeleteNoValidatedScannedDocument() {
  yield takeEvery(
    types.DELETE_NO_VALIDATED_RC_SCANNED_DOCUMENT_REQUEST,
    deleteNoValidatedScannedDocument,
  );
}
function* watcherGetNoValidatedScannedDocuments() {
  yield takeEvery(
    types.GET_NO_VALIDATED_RC_SCANNED_DOCUMENTS_REQUEST,
    getNoValidatedScannedDocuments,
  );
}

export default function* rootSaga() {
  yield all([
    fork(watcherGetNoValidatedScannedDocuments),
    fork(watcherDeleteNoValidatedScannedDocument),
  ]);
}
